export const translations = {
  en: {
    nav: {
      home: "Home", about: "About Us", products: "Products", sourcing: "Import & Sourcing",
      export: "Export", reach: "Global Reach", contact: "Contact", enquiry: "Request an Enquiry",
    },
    hero: {
      overline: "Al Nama Importer · Dubai, United Arab Emirates",
      line1: "Connecting", line2a: "Global", line2b: "Food", line3: "Markets",
      sub: "Al Nama Importer connects trusted international suppliers with buyers across the UAE, Africa and global markets through the import and export of quality food products and agro commodities.",
      ctaProducts: "Explore Our Products", ctaContact: "Contact Us", ctaMap: "View global trade map",
    },
    marquee: ["Basmati Rice", "Cardamom", "Cloves", "Cashew Kernels", "Almonds", "Chickpeas", "Yellow Lentils", "Pistachios", "Black Pepper", "Turmeric", "Dates", "Wheat Grains"],
    trust: {
      overline: "Your Partner in Global Food Trading",
      titleA: "Sourcing Quality.", titleB: "Trading Globally.",
      text: "Based in the Spice Market, Dubai, Al Nama Importer specializes in the international trading of food products and agro commodities. We source from established markets across Asia, the USA and other regions and connect quality products with buyers and markets across the UAE, Africa and beyond.",
      cards: [
        { t: "Global Sourcing", d: "International supplier network" },
        { t: "B2B Trading", d: "Focused on wholesale and commercial requirements" },
        { t: "Food & Commodities", d: "Diverse range of food products and agricultural commodities" },
        { t: "Global Markets", d: "Serving customers across the UAE, Africa and other destinations" },
      ],
    },
    homeProducts: {
      overline: "Our Products", titleA: "Traded Across", titleB: "Borders",
      text: "We trade a diverse range of food products and agro commodities sourced from international markets.",
      viewAll: "View All Products",
    },
    why: {
      overline: "Why Al Nama Importer", titleA: "Built for", titleB: "International Trade",
      cards: [
        { t: "International Network", d: "Connected with suppliers and markets across multiple regions." },
        { t: "Product Diversity", d: "Trading cereals, spices, pulses, agro commodities, nuts and dry fruits." },
        { t: "B2B Focus", d: "Focused on commercial buyers, wholesalers, distributors and trading partners." },
        { t: "Strategic UAE Location", d: "Operating from Dubai, a major international trading hub." },
        { t: "Global Sourcing", d: "Accessing products from established international markets." },
        { t: "Relationship Driven", d: "Focused on building reliable and long-term business relationships." },
      ],
    },
    cta: {
      overline: "Business Enquiry",
      titleA: "Looking for a Reliable", titleB: "Food Trading", titleC: "Partner?",
      text: "Tell us what you are looking for. Our team can discuss your product, sourcing or export requirements.",
      send: "Send an Enquiry", whatsapp: "WhatsApp Us",
    },
    about: {
      heroOver: "About Us", heroL1: "About", heroL2: "Al Nama Importer",
      heroText: "A Dubai-based international food and agro-commodities trading company focused on connecting global supply with international demand.",
      profileOver: "Company Profile", titleA: "From Dubai’s Spice Market", titleB: "to the World",
      p1: "Al Nama Importer is a Dubai-based international food and agro-commodities trading company focused on connecting global supply with international demand.",
      p2: "Operating from Dubai’s Spice Market, the company works across international sourcing and trading channels for cereals, spices, pulses, agro commodities, nuts and dry fruits.",
      p3: "Our sourcing network extends across markets including India, Pakistan, Bangladesh, Nepal, Vietnam, California/USA, Afghanistan and other regions. We also work with international buyers and markets across Africa and other destinations.",
      p4: "Our focus is simple: understand market requirements, source suitable products and build dependable long-term trading relationships.",
      rakezText: "Al Nama Importer is registered with RAKEZ, United Arab Emirates.",
      manifOver: "The Al Nama Manifesto", manifTitleA: "Four Chapters of", manifTitleB: "How We Trade",
      chapters: [
        { t: "A Global Sourcing Network", d: "Our sourcing network extends across markets including India, Pakistan, Bangladesh, Nepal, Vietnam, California/USA, Afghanistan and other regions — connecting food-producing markets with international demand." },
        { t: "Dubai, At the Crossroads of Trade", d: "Operating from Dubai's Spice Market — one of the region's established trading areas for spices, food products and commodities — Al Nama Importer works at the heart of a major international trading hub." },
        { t: "Focused on B2B Trade", d: "We serve wholesalers, distributors, retailers, food businesses and international trading partners, aligning products with commercial specifications and market requirements." },
        { t: "Relationships That Last", d: "Our focus is simple: understand market requirements, source suitable products and build dependable long-term trading relationships." },
      ],
    },
    productsPage: {
      heroOver: "Our Products", heroL1: "Food Products &", heroL2: "Agro Commodities",
      heroText: "We trade a diverse range of food products and agro commodities sourced from international markets.",
      note: "Product availability, origins and specifications are aligned to buyer requirements and market conditions. Share your requirement and our team will respond with suitable options.",
      enquire: "Request an Enquiry",
    },
    products: {
      cereals: {
        name: "Cereals",
        desc: "Rice, grains and other cereal products sourced for wholesale and commercial requirements.",
        intro: "We source rice, grains and other cereal products from established international markets for wholesalers, distributors and commercial buyers.",
        items: ["Rice", "Wheat", "Grains", "Other Cereal Products"],
      },
      spices: {
        name: "Spices",
        desc: "A range of whole and processed spices sourced from established producing markets.",
        intro: "A range of whole and processed spices sourced from established producing markets, aligned to commercial specifications and buyer requirements.",
        items: ["Cardamom", "Cloves", "Black Pepper", "Turmeric", "Cumin", "Cinnamon"],
      },
      pulses: {
        name: "Pulses",
        desc: "Pulses, lentils and related products for wholesalers, distributors and commercial buyers.",
        intro: "Pulses, lentils and related products sourced for wholesalers, distributors and commercial buyers across our markets.",
        items: ["Lentils", "Chickpeas", "Beans", "Other Pulses"],
      },
      agro: {
        name: "Agro Commodities",
        desc: "Agricultural commodities sourced according to market and buyer requirements.",
        intro: "Agricultural commodities sourced according to market demand and buyer requirements, coordinated through our Dubai trading base.",
        items: ["Seasonal Commodities", "Field Crops", "Agricultural Produce"],
      },
      nuts: {
        name: "Nuts",
        desc: "Quality nuts sourced from international markets.",
        intro: "Quality nuts sourced from international markets for wholesale and commercial distribution.",
        items: ["Almonds", "Cashews", "Pistachios", "Other Quality Nuts"],
      },
      dryFruits: {
        name: "Dry Fruits",
        desc: "A selection of dry fruits suitable for wholesale and commercial distribution.",
        intro: "A selection of dry fruits suitable for wholesale and commercial distribution across regional and international markets.",
        items: ["Dates", "Raisins", "Dried Figs", "Dried Apricots"],
      },
    },
    detail: {
      back: "All Products", includes: "What We Trade in This Category",
      sourcingT: "Sourcing", sourcingX: "Products in this category are sourced based on product requirements, market demand and commercial specifications.",
      buyersT: "Who We Serve", buyersX: "Wholesalers, distributors, retailers, food businesses and international trading partners.",
      enquire: "Enquire About This Category",
      availNote: "Availability, origins and specifications are subject to buyer requirements and market conditions.",
      next: "Next", prev: "Previous",
    },
    sourcingPage: {
      heroOver: "Import & Sourcing", heroL1: "Global Sourcing", heroL2: "& Import",
      heroText: "Our international sourcing activities connect Al Nama Importer with food-producing and trading markets across Asia, the USA and other regions.",
      marketsOver: "Where We Source", marketsTitleA: "Established Markets,", marketsTitleB: "Trusted Origins",
      marketsText: "Products are sourced based on product requirements, market demand and commercial specifications.",
      originTag: "Sourcing origin",
      howOver: "How It Works", howTitleA: "From Requirement", howTitleB: "to Shipment",
      steps: [
        { t: "Share Your Requirement", d: "Tell us the product, specification and commercial requirements you are working with." },
        { t: "We Source Internationally", d: "Products are sourced from established international markets based on product requirements, market demand and commercial specifications." },
        { t: "Trade Through Dubai", d: "Sourcing and trading are coordinated from our base in Dubai, connecting suppliers with buyers across our markets." },
      ],
      cta: "Discuss Your Sourcing Requirement",
    },
    markets: ["India", "Pakistan", "Bangladesh", "Nepal", "Vietnam", "California / USA", "Afghanistan", "Other International Markets"],
    exportPage: {
      heroOver: "Export", heroL1: "Taking Quality Products", heroL2: "to Global Markets",
      heroText: "From our base in the UAE, Al Nama Importer supports international trade and export opportunities across Africa and other global destinations.",
      focusOver: "What We Focus On", focusTitleA: "Export, Handled", focusTitleB: "End to End",
      focus: ["International B2B Trade", "Wholesale Requirements", "Product Sourcing", "Export Coordination", "Buyer Requirements", "Long-Term Trading Relationships"],
      routeOver: "The Trade Route",
      routeTitleA: "International Suppliers", routeTitleB: "Africa & Global Markets",
      origin: "Origin", hub: "Hub", dest: "Destination",
      nodes: ["International Suppliers", "UAE — Al Nama Importer", "Africa & Global Markets"],
      cta: "Start an Export Enquiry",
    },
    reach: {
      heroOver: "Global Reach", heroL1: "From Global Sources", heroL2: "to Global Markets",
      heroText: "Al Nama Importer operates as an international bridge between food-producing regions and global buyers.",
      legendSrc: "Sourcing markets", legendHub: "Dubai · UAE hub", legendDst: "Export markets",
      srcOver: "Sourcing Markets", srcTitle: "Where Our Products Begin",
      dstOver: "Export Markets", dstTitle: "Where Our Products Arrive",
      destMarkets: ["UAE", "Africa", "Other International Destinations"],
      dstText: "From our base in the UAE, we connect international supply with buyers and markets across Africa and other destinations.",
    },
    contactPage: {
      heroOver: "Contact", heroL1: "Let’s Trade", heroL2: "Globally",
      heroText: "Whether you are looking to source food products, discuss an import requirement or explore export opportunities, get in touch with Al Nama Importer.",
      visit: "Visit Us", call: "Call Us", email: "Email Us",
      whatsapp: "WhatsApp", callBtn: "Call Us", emailBtn: "Email Us",
      formOver: "Business Enquiry Form", formTitle: "Tell Us What You’re Looking For",
      officesOver: "Our Offices", officesTitleA: "Two Offices,", officesTitleB: "One Trading Network",
      uaeOffice: "UAE Head Office", indiaOffice: "India Branch Office",
      indiaTag: "Sourcing & supplier coordination across India",
      ceoTitle: "CEO – India Branch",
    },
    form: {
      name: "Full Name *", namePh: "Your full name",
      company: "Company Name", companyPh: "Your company",
      country: "Country *", countryPh: "Country",
      email: "Email Address *", emailPh: "you@company.com",
      phone: "Phone / WhatsApp *", phonePh: "+971 ...",
      type: "Enquiry Type *", product: "Product Interested In",
      message: "Message *", messagePh: "Tell us about your product, sourcing or export requirement...",
      submit: "Submit Enquiry", sending: "Sending...",
      successTitle: "Enquiry Received",
      successText: "Thank you. Your enquiry has been received. Our team will get back to you shortly.",
      another: "Send another enquiry",
      selectType: "Select enquiry type", selectProduct: "Select a product category",
      types: ["Product Enquiry", "Import Requirement", "Export Requirement", "Sourcing Requirement", "Partnership", "Other"],
      productOptions: ["Cereals", "Spices", "Pulses", "Agro Commodities", "Nuts", "Dry Fruits", "Other"],
      error: "Your enquiry could not be sent. Please try again or reach us on WhatsApp.",
      modalOver: "Business Enquiry", modalTitle: "Let’s Discuss Your Requirement",
    },
    footer: {
      blurb: "Dubai-based international trading company specializing in the import and export of food products and agro commodities.",
      rakez: "Registered with RAKEZ, United Arab Emirates",
      navigate: "Navigate", contactT: "Contact", productsT: "Products",
      productsList: "Cereals · Spices · Pulses · Agro Commodities · Nuts · Dry Fruits",
      privacy: "Privacy Policy", terms: "Terms & Conditions",
      copyright: "© 2026 Al Nama Importer. All Rights Reserved.",
      locationTag: "Spice Market · Dubai · UAE", contactUs: "Contact Us",
    },
    wa: { label: "WhatsApp Us", aria: "Chat with Al Nama Importer on WhatsApp" },
    card: { enquire: "Enquire Now", details: "View Details" },
    legal: {
      over: "Legal",
      privacyTitle: "Privacy Policy",
      termsTitle: "Terms & Conditions",
      privacy: [
        { t: "Information We Collect", d: "When you submit an enquiry through our website, we collect the details you provide — including your name, company name, country, email address, phone number and the content of your message — solely to respond to your business enquiry." },
        { t: "How We Use Your Information", d: "Your information is used only to communicate with you about your enquiry, product, sourcing or export requirements. We do not sell or share your information with third parties for marketing purposes." },
        { t: "Data Retention", d: "Enquiry records are retained for business communication purposes. You may request the removal of your information at any time by contacting us by email." },
        { t: "Contact", d: "Al Nama Importer, Compass Building, Al Hamra Industrial Zone, Ras Al Khaimah, UAE." },
      ],
      terms: [
        { t: "About This Website", d: "This website is operated by Al Nama Importer, a food and agro-commodities trading company based at Compass Building, Al Hamra Industrial Zone, Ras Al Khaimah, UAE, registered with RAKEZ, United Arab Emirates." },
        { t: "Informational Content", d: "The content of this website is provided for general business information. Product availability, origins, specifications and commercial terms are subject to individual discussion and agreement between the parties." },
        { t: "Enquiries", d: "Submitting an enquiry through this website does not constitute a binding commercial agreement. All trading terms are confirmed separately in writing between Al Nama Importer and the respective buyer or supplier." },
        { t: "Contact", d: "For questions regarding these terms, contact us by email or phone." },
      ],
    },
  },

  ar: {
    nav: {
      home: "الرئيسية", about: "من نحن", products: "منتجاتنا", sourcing: "الاستيراد والتوريد",
      export: "التصدير", reach: "الانتشار العالمي", contact: "اتصل بنا", enquiry: "طلب استفسار",
    },
    hero: {
      overline: "النعم للاستيراد · دبي، الإمارات العربية المتحدة",
      line1: "نربط", line2a: "أسواق", line2b: "الغذاء", line3: "العالمية",
      sub: "تربط شركة النعم للاستيراد المورّدين الدوليين الموثوقين بالمشترين في الإمارات وأفريقيا والأسواق العالمية، من خلال استيراد وتصدير المنتجات الغذائية والسلع الزراعية عالية الجودة.",
      ctaProducts: "استكشف منتجاتنا", ctaContact: "اتصل بنا", ctaMap: "شاهد خريطة التجارة العالمية",
    },
    marquee: ["أرز باسمتي", "هيل", "قرنفل", "كاجو", "لوز", "حمص", "عدس أصفر", "فستق", "فلفل أسود", "كركم", "تمر", "حبوب القمح"],
    trust: {
      overline: "شريكك في تجارة الغذاء العالمية",
      titleA: "جودة في التوريد.", titleB: "تجارة عالمية.",
      text: "من مقرها في سوق التوابل بدبي، تتخصص شركة النعم للاستيراد في التجارة الدولية للمنتجات الغذائية والسلع الزراعية. نورد من أسواق راسخة في آسيا والولايات المتحدة ومناطق أخرى، ونوصل المنتجات عالية الجودة إلى المشترين والأسواق في الإمارات وأفريقيا وما وراءها.",
      cards: [
        { t: "التوريد العالمي", d: "شبكة موردين دولية" },
        { t: "تجارة بين الشركات", d: "تركيز على متطلبات الجملة والتجارة" },
        { t: "الغذاء والسلع", d: "مجموعة متنوعة من المنتجات الغذائية والسلع الزراعية" },
        { t: "الأسواق العالمية", d: "خدمة العملاء في الإمارات وأفريقيا ووجهات أخرى" },
      ],
    },
    homeProducts: {
      overline: "منتجاتنا", titleA: "منتجات تعبر", titleB: "الحدود",
      text: "نتاجر في مجموعة متنوعة من المنتجات الغذائية والسلع الزراعية الموردة من الأسواق الدولية.",
      viewAll: "عرض جميع المنتجات",
    },
    why: {
      overline: "لماذا النعم للاستيراد", titleA: "مصممون", titleB: "للتجارة الدولية",
      cards: [
        { t: "شبكة دولية", d: "نتصل بموردين وأسواق عبر مناطق متعددة." },
        { t: "تنوع المنتجات", d: "نتاجر في الحبوب والتوابل والبقوليات والسلع الزراعية والمكسرات والفواكه المجففة." },
        { t: "تركيز على الشركات", d: "نركز على المشترين التجاريين وتجار الجملة والموزعين وشركاء التجارة." },
        { t: "موقع استراتيجي في الإمارات", d: "نعمل من دبي، أحد أهم مراكز التجارة الدولية." },
        { t: "توريد عالمي", d: "نصل إلى المنتجات من أسواق دولية راسخة." },
        { t: "علاقات طويلة الأمد", d: "نركز على بناء علاقات تجارية موثوقة وطويلة الأمد." },
      ],
    },
    cta: {
      overline: "استفسار تجاري",
      titleA: "هل تبحث عن شريك موثوق", titleB: "في تجارة الغذاء", titleC: "؟",
      text: "أخبرنا بما تبحث عنه. يمكن لفريقنا مناقشة متطلباتك في المنتجات أو التوريد أو التصدير.",
      send: "أرسل استفساراً", whatsapp: "راسلنا على واتساب",
    },
    about: {
      heroOver: "من نحن", heroL1: "عن شركة", heroL2: "النعم للاستيراد",
      heroText: "شركة تجارة دولية للمنتجات الغذائية والسلع الزراعية مقرها دبي، تركز على ربط العرض العالمي بالطلب الدولي.",
      profileOver: "الملف التعريفي", titleA: "من سوق التوابل في دبي", titleB: "إلى العالم",
      p1: "النعم للاستيراد هي شركة تجارة دولية للمنتجات الغذائية والسلع الزراعية مقرها دبي، تركز على ربط العرض العالمي بالطلب الدولي.",
      p2: "من مقرها في سوق التوابل بدبي، تعمل الشركة عبر قنوات التوريد والتجارة الدولية للحبوب والتوابل والبقوليات والسلع الزراعية والمكسرات والفواكه المجففة.",
      p3: "تمتد شبكة التوريد لدينا عبر أسواق تشمل الهند وباكستان وبنغلاديش ونيبال وفيتنام وكاليفورنيا/الولايات المتحدة وأفغانستان ومناطق أخرى. كما نعمل مع مشترين وأسواق دولية في أفريقيا ووجهات أخرى.",
      p4: "تركيزنا بسيط: فهم متطلبات السوق، وتوريد المنتجات المناسبة، وبناء علاقات تجارية موثوقة وطويلة الأمد.",
      rakezText: "شركة النعم للاستيراد مسجلة لدى راكز (RAKEZ)، الإمارات العربية المتحدة.",
      manifOver: "مانيفستو النعم", manifTitleA: "أربعة فصول عن", manifTitleB: "كيف نتاجر",
      chapters: [
        { t: "شبكة توريد عالمية", d: "تمتد شبكة التوريد لدينا عبر أسواق تشمل الهند وباكستان وبنغلاديش ونيبال وفيتنام وكاليفورنيا/الولايات المتحدة وأفغانستان ومناطق أخرى — لتربط الأسواق المنتجة للغذاء بالطلب الدولي." },
        { t: "دبي، عند مفترق طرق التجارة", d: "من مقرها في سوق التوابل بدبي — أحد أعرق مناطق تجارة التوابل والمنتجات الغذائية والسلع في المنطقة — تعمل النعم للاستيراد في قلب مركز تجاري دولي رئيسي." },
        { t: "تركيز على تجارة الشركات", d: "نخدم تجار الجملة والموزعين وتجار التجزئة وشركات الأغذية وشركاء التجارة الدوليين، مع مواءمة المنتجات مع المواصفات التجارية ومتطلبات السوق." },
        { t: "علاقات تدوم", d: "تركيزنا بسيط: فهم متطلبات السوق، وتوريد المنتجات المناسبة، وبناء علاقات تجارية موثوقة وطويلة الأمد." },
      ],
    },
    productsPage: {
      heroOver: "منتجاتنا", heroL1: "المنتجات الغذائية", heroL2: "والسلع الزراعية",
      heroText: "نتاجر في مجموعة متنوعة من المنتجات الغذائية والسلع الزراعية الموردة من الأسواق الدولية.",
      note: "تخضع توافر المنتجات وأصولها ومواصفاتها لمتطلبات المشتري وظروف السوق. شاركنا متطلباتك وسيرد فريقنا بالخيارات المناسبة.",
      enquire: "طلب استفسار",
    },
    products: {
      cereals: {
        name: "الحبوب الغذائية",
        desc: "الأرز والحبوب ومنتجات الحبوب الأخرى الموردة لمتطلبات الجملة والتجارة.",
        intro: "نورد الأرز والحبوب ومنتجات الحبوب الأخرى من أسواق دولية راسخة لتجار الجملة والموزعين والمشترين التجاريين.",
        items: ["الأرز", "القمح", "الحبوب", "منتجات الحبوب الأخرى"],
      },
      spices: {
        name: "التوابل",
        desc: "مجموعة من التوابل الكاملة والمصنعة من أسواق الإنتاج الراسخة.",
        intro: "مجموعة من التوابل الكاملة والمصنعة الموردة من أسواق إنتاج راسخة، بما يتوافق مع المواصفات التجارية ومتطلبات المشترين.",
        items: ["الهيل", "القرنفل", "الفلفل الأسود", "الكركم", "الكمون", "القرفة"],
      },
      pulses: {
        name: "البقوليات",
        desc: "البقوليات والعدس والمنتجات ذات الصلة لتجار الجملة والموزعين والمشترين التجاريين.",
        intro: "البقوليات والعدس والمنتجات ذات الصلة الموردة لتجار الجملة والموزعين والمشترين التجاريين عبر أسواقنا.",
        items: ["العدس", "الحمص", "الفول", "بقوليات أخرى"],
      },
      agro: {
        name: "السلع الزراعية",
        desc: "سلع زراعية يتم توريدها وفقاً لمتطلبات السوق والمشتري.",
        intro: "سلع زراعية يتم توريدها وفقاً لطلب السوق ومتطلبات المشتري، بتنسيق من قاعدتنا التجارية في دبي.",
        items: ["السلع الموسمية", "المحاصيل الحقلية", "المنتجات الزراعية"],
      },
      nuts: {
        name: "المكسرات",
        desc: "مكسرات عالية الجودة من الأسواق الدولية.",
        intro: "مكسرات عالية الجودة موردة من الأسواق الدولية للجملة والتوزيع التجاري.",
        items: ["اللوز", "الكاجو", "الفستق", "مكسرات أخرى عالية الجودة"],
      },
      dryFruits: {
        name: "الفواكه المجففة",
        desc: "تشكيلة من الفواكه المجففة المناسبة للجملة والتوزيع التجاري.",
        intro: "تشكيلة من الفواكه المجففة المناسبة للجملة والتوزيع التجاري عبر الأسواق الإقليمية والدولية.",
        items: ["التمر", "الزبيب", "التين المجفف", "المشمش المجفف"],
      },
    },
    detail: {
      back: "جميع المنتجات", includes: "ماذا نتاجر في هذه الفئة",
      sourcingT: "التوريد", sourcingX: "يتم توريد المنتجات في هذه الفئة بناءً على متطلبات المنتج وطلب السوق والمواصفات التجارية.",
      buyersT: "لمن نورد", buyersX: "تجار الجملة والموزعون وتجار التجزئة وشركات الأغذية وشركاء التجارة الدوليون.",
      enquire: "استفسر عن هذه الفئة",
      availNote: "تخضع التوافر والأصول والمواصفات لمتطلبات المشتري وظروف السوق.",
      next: "التالي", prev: "السابق",
    },
    sourcingPage: {
      heroOver: "الاستيراد والتوريد", heroL1: "التوريد العالمي", heroL2: "والاستيراد",
      heroText: "تربط أنشطة التوريد الدولية لدينا شركة النعم للاستيراد بأسواق إنتاج وتجارة الغذاء في آسيا والولايات المتحدة ومناطق أخرى.",
      marketsOver: "من أين نورد", marketsTitleA: "أسواق راسخة،", marketsTitleB: "مصادر موثوقة",
      marketsText: "يتم توريد المنتجات بناءً على متطلبات المنتج وطلب السوق والمواصفات التجارية.",
      originTag: "مصدر التوريد",
      howOver: "كيف نعمل", howTitleA: "من المتطلبات", howTitleB: "إلى الشحنة",
      steps: [
        { t: "شاركنا متطلباتك", d: "أخبرنا بالمنتج والمواصفات والمتطلبات التجارية التي تعمل عليها." },
        { t: "نورد دولياً", d: "يتم توريد المنتجات من أسواق دولية راسخة بناءً على متطلبات المنتج وطلب السوق والمواصفات التجارية." },
        { t: "التجارة عبر دبي", d: "يتم تنسيق التوريد والتجارة من قاعدتنا في دبي، لربط الموردين بالمشترين عبر أسواقنا." },
      ],
      cta: "ناقش متطلبات التوريد الخاصة بك",
    },
    markets: ["الهند", "باكستان", "بنغلاديش", "نيبال", "فيتنام", "كاليفورنيا / الولايات المتحدة", "أفغانستان", "أسواق دولية أخرى"],
    exportPage: {
      heroOver: "التصدير", heroL1: "نوصل المنتجات عالية الجودة", heroL2: "إلى الأسواق العالمية",
      heroText: "من قاعدتنا في الإمارات، تدعم النعم للاستيراد فرص التجارة الدولية والتصدير إلى أفريقيا ووجهات عالمية أخرى.",
      focusOver: "ما نركز عليه", focusTitleA: "التصدير،", focusTitleB: "من البداية إلى النهاية",
      focus: ["التجارة الدولية بين الشركات", "متطلبات الجملة", "توريد المنتجات", "تنسيق التصدير", "متطلبات المشترين", "علاقات تجارية طويلة الأمد"],
      routeOver: "طريق التجارة",
      routeTitleA: "الموردون الدوليون", routeTitleB: "أفريقيا والأسواق العالمية",
      origin: "المصدر", hub: "المركز", dest: "الوجهة",
      nodes: ["الموردون الدوليون", "الإمارات — النعم للاستيراد", "أفريقيا والأسواق العالمية"],
      cta: "ابدأ استفسار تصدير",
    },
    reach: {
      heroOver: "الانتشار العالمي", heroL1: "من مصادر عالمية", heroL2: "إلى أسواق عالمية",
      heroText: "تعمل النعم للاستيراد كجسر دولي بين المناطق المنتجة للغذاء والمشترين العالميين.",
      legendSrc: "أسواق التوريد", legendHub: "دبي · مركز الإمارات", legendDst: "أسواق التصدير",
      srcOver: "أسواق التوريد", srcTitle: "من أين تبدأ منتجاتنا",
      dstOver: "أسواق التصدير", dstTitle: "أين تصل منتجاتنا",
      destMarkets: ["الإمارات العربية المتحدة", "أفريقيا", "وجهات دولية أخرى"],
      dstText: "من قاعدتنا في الإمارات، نربط العرض الدولي بالمشترين والأسواق في أفريقيا ووجهات أخرى.",
    },
    contactPage: {
      heroOver: "اتصل بنا", heroL1: "لنتاجر", heroL2: "عالمياً",
      heroText: "سواء كنت تبحث عن توريد منتجات غذائية، أو مناقشة متطلبات استيراد، أو استكشاف فرص التصدير، تواصل مع شركة النعم للاستيراد.",
      visit: "زورونا", call: "اتصل بنا", email: "راسلنا عبر البريد",
      whatsapp: "واتساب", callBtn: "اتصل بنا", emailBtn: "راسلنا",
      formOver: "نموذج الاستفسار التجاري", formTitle: "أخبرنا بما تبحث عنه",
      officesOver: "مكاتبنا", officesTitleA: "مكتبان،", officesTitleB: "شبكة تجارية واحدة",
      uaeOffice: "المكتب الرئيسي – الإمارات", indiaOffice: "فرع الهند",
      indiaTag: "التوريد وتنسيق الموردين عبر الهند",
      ceoTitle: "الرئيس التنفيذي – فرع الهند",
    },
    form: {
      name: "الاسم الكامل *", namePh: "اسمك الكامل",
      company: "اسم الشركة", companyPh: "شركتك",
      country: "الدولة *", countryPh: "الدولة",
      email: "البريد الإلكتروني *", emailPh: "you@company.com",
      phone: "الهاتف / واتساب *", phonePh: "+971 ...",
      type: "نوع الاستفسار *", product: "المنتج المطلوب",
      message: "الرسالة *", messagePh: "أخبرنا عن متطلباتك في المنتجات أو التوريد أو التصدير...",
      submit: "إرسال الاستفسار", sending: "جارٍ الإرسال...",
      successTitle: "تم استلام الاستفسار",
      successText: "شكراً لك. تم استلام استفسارك وسيتواصل معك فريقنا قريباً.",
      another: "أرسل استفساراً آخر",
      selectType: "اختر نوع الاستفسار", selectProduct: "اختر فئة المنتج",
      types: ["استفسار عن منتج", "متطلبات استيراد", "متطلبات تصدير", "متطلبات توريد", "شراكة", "أخرى"],
      productOptions: ["الحبوب الغذائية", "التوابل", "البقوليات", "السلع الزراعية", "المكسرات", "الفواكه المجففة", "أخرى"],
      error: "تعذر إرسال استفسارك. يرجى المحاولة مرة أخرى أو التواصل معنا عبر واتساب.",
      modalOver: "استفسار تجاري", modalTitle: "لنناقش متطلباتك",
    },
    footer: {
      blurb: "شركة تجارة دولية مقرها دبي، متخصصة في استيراد وتصدير المنتجات الغذائية والسلع الزراعية.",
      rakez: "مسجلة لدى راكز، الإمارات العربية المتحدة",
      navigate: "تصفح", contactT: "تواصل", productsT: "المنتجات",
      productsList: "الحبوب · التوابل · البقوليات · السلع الزراعية · المكسرات · الفواكه المجففة",
      privacy: "سياسة الخصوصية", terms: "الشروط والأحكام",
      copyright: "© 2026 النعم للاستيراد. جميع الحقوق محفوظة.",
      locationTag: "سوق التوابل · دبي · الإمارات", contactUs: "اتصل بنا",
    },
    wa: { label: "راسلنا على واتساب", aria: "تحدث مع النعم للاستيراد عبر واتساب" },
    card: { enquire: "استفسر الآن", details: "عرض التفاصيل" },
    legal: {
      over: "قانوني",
      privacyTitle: "سياسة الخصوصية",
      termsTitle: "الشروط والأحكام",
      privacy: [
        { t: "المعلومات التي نجمعها", d: "عند إرسال استفسار عبر موقعنا، نجمع التفاصيل التي تقدمها — بما في ذلك اسمك واسم شركتك ودولتك وبريدك الإلكتروني ورقم هاتفك ومحتوى رسالتك — وذلك فقط للرد على استفسارك التجاري." },
        { t: "كيف نستخدم معلوماتك", d: "تُستخدم معلوماتك فقط للتواصل معك بشأن استفسارك أو متطلبات المنتجات أو التوريد أو التصدير. لا نبيع معلوماتك أو نشاركها مع أطراف ثالثة لأغراض تسويقية." },
        { t: "الاحتفاظ بالبيانات", d: "يتم الاحتفاظ بسجلات الاستفسارات لأغراض التواصل التجاري. يمكنك طلب حذف معلوماتك في أي وقت عبر التواصل معنا بالبريد الإلكتروني." },
        { t: "تواصل", d: "النعم للاستيراد، مبنى كومباس، منطقة الحمرا الصناعية، رأس الخيمة، الإمارات العربية المتحدة." },
      ],
      terms: [
        { t: "عن هذا الموقع", d: "يتم تشغيل هذا الموقع من قبل شركة النعم للاستيراد، شركة تجارة المنتجات الغذائية والسلع الزراعية، ومقرها مبنى كومباس، منطقة الحمرا الصناعية، رأس الخيمة، الإمارات العربية المتحدة، ومسجلة لدى راكز (RAKEZ)." },
        { t: "محتوى معلوماتي", d: "يُقدم محتوى هذا الموقع لأغراض المعلومات التجارية العامة. تخضع توافر المنتجات وأصولها ومواصفاتها وشروطها التجارية للنقاش والاتفاق الفردي بين الطرفين." },
        { t: "الاستفسارات", d: "إرسال استفسار عبر هذا الموقع لا يشكل اتفاقاً تجارياً ملزماً. يتم تأكيد جميع الشروط التجارية كتابياً بشكل منفصل بين النعم للاستيراد والمشتري أو المورد المعني." },
        { t: "تواصل", d: "للاستفسار عن هذه الشروط، تواصل معنا عبر البريد الإلكتروني أو الهاتف." },
      ],
    },
  },
};
